<template>
    <div>
        <div v-for="question in model.questions" v-bind:key="question.uid">
            <transition name="fade">
                <question v-show="!question.hide_by_depend"
                          v-if="!question.is_hidden"
                          @questionFill="changeRequired"
                          @checkDependency="checkDependency"
                          :replaces="replaces"
                          :model="question"></question>
            </transition>
        </div>

    </div>
</template>

<script>
    import Question from '../ui/Question'

    export default {
        name: 'block',
        props: ['model', 'replaces'],
        data() {
            return {}
        },
        mounted() {
        },
        methods: {
            changeRequired(event) {
                this.$emit("checkRequired", event);
            },
            checkDependency: function (answer_uid) {
                this.$emit("checkDependency", answer_uid);
            }
        },
        components: {
            Question
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .10s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
</style>
